import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import RoomIcon from '@mui/icons-material/Room'

import { TRANSLATIONS as T } from '../../../constants/translations-constants'
import { useTranslate } from '../../../hooks/shared'

const useRFFCustomLocationButtonStyles = makeStyles()((theme: Theme) => ({
  button: {
    color: theme.palette.info.dark,
    fontWeight: 400,
    fontSize: '16px',
    border: 'none',
    height: '50px',
    width: '100%',
    borderRadius: '8px',
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
    marginBottom: '20px',
    textTransform: 'none',
    // Was on v4's inner `label` span, which v5 no longer renders.
    justifyContent: 'space-between',
    '&:hover': {
      border: 'none',
    },
  },
}))

interface LocationButtonProps {
  clickHandler(): void
}

const RFFCustomLocationButton: FC<LocationButtonProps> = ({ clickHandler }) => {
  const { t } = useTranslate(T.FNOL_OTHER_WHEN_WHERE)
  const { classes } = useRFFCustomLocationButtonStyles()

  return (
    <Button
      onClick={() => clickHandler()}
      color='primary'
      className={classes.button}
      endIcon={<RoomIcon color='primary' />}
      disableRipple
    >
      {t('locationBtn')}
    </Button>
  )
}

export default RFFCustomLocationButton
